import React from 'react';
import { capitalize } from 'lodash';
import { getOrgTermsContent } from '../../../../content/utils.js';
import PageHeader from '../../PageHeader.js';
import BreadCrumbs from '../../../BreadCrumbs.jsx';
import ProjectBreadcrumbIcon from '../../../icons/ProjectBreadcrumbIcon.jsx';
import { ProjectLink, ProjectsLink } from '../../../links/index.jsx';

const InitiativeFormHeader = ({ project, initiativeType }) => {
  return (
    <PageHeader flex>
      <BreadCrumbs icon={<ProjectBreadcrumbIcon />}>
        <ProjectsLink>{getOrgTermsContent('projects')}</ProjectsLink>

        {project ? (
          <ProjectLink projectId={project.id}>{project.name}</ProjectLink>
        ) : null}

        {!project ? (
          <span>Edit {capitalize(initiativeType)}</span>
        ) : (
          <span>Add {capitalize(initiativeType)}</span>
        )}
      </BreadCrumbs>
    </PageHeader>
  );
};

export default InitiativeFormHeader;
